import { render, staticRenderFns } from "./collectForm.vue?vue&type=template&id=37c3b430"
import script from "./collectForm.vue?vue&type=script&lang=js"
export * from "./collectForm.vue?vue&type=script&lang=js"
import style0 from "./collectForm.vue?vue&type=style&index=0&id=37c3b430&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports